/**
 * @module cc
 */
/**
 * Class for Font handling.
 * @class Font
 * @extends RawAsset
 * @constructor
 */
var Font = cc.Class({
    name: 'cc.Font',
    extends: cc.RawAsset
});

cc.Font = Font;
module.exports = Font;
